import React from 'react';
import ReactPanZoom from 'react-image-pan-zoom-rotate';

import { ModalTemplate } from 'components/ModalTemplate';

export interface StateProps {
  image: string;
}

type Props = StateProps;

const DialogImage: React.FC<Props> = ({ image }) => (
  <ModalTemplate hideCloseIcon>
    <ReactPanZoom image={image} alt={`imagem ${image}`} />
  </ModalTemplate>
);

export default DialogImage;
export { DialogImage };
